<template>
  <div id="OpenApi" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">O</span>pen API</div>
        <div class="col-3 t-r f22 pr3"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;">
      <div class="col-12 bb1" v-for="(open,open_i) in data_list" v-bind:key="open_i" @click="go_open_api_setting(open.open_id)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-2 pt15 pl10">
                <i class="iconfont icon-share f24"></i>
              </div>
              <div class="col-8 pl10 pt8">
                <div class="col-12 f14">{{ open.open_id }}</div>
                <div class="col-12 f14 uppercase fw">{{ open.name }}</div>
              </div>
              <div class="col-2 color-muted t-r lh50 pr5">
                <i class="iconfont icon-31fanhui2"></i>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OpenApi',
  data () {
    return {
      data_list: [],
    }
  },
  created: function () {
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      this.post(this.api_url + 'manage/open_api_list', post_data).then((res)=>{
        if(res.status == 1){
          console.log(res.data);
          this.data_list = res.data;
        }else{
          this.data_list = []
        }
      })
    },
    //打开API设置
    go_open_api_setting(open_id) {
      this.$router.push({name: 'M_OpenApiSetting', query: {open_id: open_id}});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/OpenApi.vue